<div *ngIf="isLoading" class="row">
    <div class="col-md-12 no-padding">
        <app-page-loading></app-page-loading>
    </div>
</div>
<div *ngIf="accessdenied && !isLoading" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied && !isLoading" class="row" style=" margin-right: 20px; margin-left: 20px; margin-bottom: 20px;">
    <div class="col-md-12 no-padding">

        <div class="row">
            <div class="col-xl-12 cover-photo-box default-bg"
                 [ngStyle]="{'background-image': 'url(' + form.coverPhoto + ')', 'height':'350px'}">

            </div>

        </div>
        <div class="row block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            <h2 style="padding-left:50px;padding-right:50px;font-size: 35px;" class="text-center profile-name">{{form.name}}</h2>

            <div class="col-md-12 col-sm-12 ">

                <div class="row small-section-content" style="margin-bottom:20px">
                    <div class="col-xl-12 text-center empty no-padding">
                        <div style="text-align: left;padding-top: 10px;" [innerHTML]="form.description">
                        </div>
                    </div>
                    <div *ngIf="isRegistred" class="col-xl-12 text-center" style="margin-top:20px">
                        <div class="alert alert-info text-center" role="alert">
                            You already submitted the form.
                        </div>
                    </div>
                </div>


                <mat-stepper [linear]="isLinear" #stepper>

                    <mat-step *ngFor="let step of form.formSteps; let i = index" [editable]="true">
                        <ng-template matStepLabel>{{step.stepName}}</ng-template>

                        <div *ngIf="step.stepCode=='@personal'" class="row">
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom: 20px; margin-top: 10px">
                                <div class="form-floating" style="margin-right:5px">
                                    <input [(ngModel)]="authentication.userData.eMail" disabled type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Email Address</label>
                                </div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom: 20px; margin-top: 10px">
                                <div class="form-floating " style="margin-left: 5px; ">
                                    <input [(ngModel)]="authentication.userData.portalAccount.name" disabled type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Company</label>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="step.stepCode=='@personal'" class="row">
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                                <div class="form-floating" style="margin-right: 5px;">
                                    <input [(ngModel)]="authentication.userData.firstName" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">First name</label>
                                </div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom: 20px">
                                <div class="form-floating" style="margin-left: 5px; ">
                                    <input [(ngModel)]="authentication.userData.lastName" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Last name</label>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="step.stepCode=='@personal'" class="row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                <div class="form-floating">
                                    <input [(ngModel)]="authentication.userData.title" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Job title</label>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="step.stepCode=='@personal'" class="row">
                            <div  class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom: 20px">
                                <label class="col-form-label" style="font-size: 12px; color: #818181; position: absolute; top: 6px; left: 14px; ">Mobile Number</label>
                                <div id="edit_phone" class="form-group">
                                    <form class="example-form" style=" padding: 0px; margin-top: 7px; margin-right: 5px;" [formGroup]="mobileLoginForm">
                                        <ngx-mat-intl-tel-input [disabled]="phoneDisabled" style="height:58px" class="form-control" [preferredCountries]="['ae', 'sa', 'jo']"
                                                                [enablePlaceholder]="true"
                                                                [enableSearch]="true"
                                                                name="phone" formControlName="phone"
                                                                describedBy="phoneInput"></ngx-mat-intl-tel-input>
                                    </form>
                                </div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                                <div class="form-floating" style="margin-left: 5px;">
                                    <select (change)="genderChangeValue($event)" class="form-select" id="floatingSelect" aria-label="Floating label select example">
                                        <option value="">
                                            Prefer not to specify
                                        </option>
                                        <option value="Male">
                                            Male
                                        </option>
                                        <option value="Female">
                                            Female
                                        </option>
                                    </select>
                                    <label for="floatingSelect">Gender</label>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="step.stepCode=='@personal'" id="countrydiv" class="row">
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                                <div class="form-floating" style="margin-right: 5px;">
                                    <select (change)="nationalityChangeValue($event)" class="form-select" id="floatingSelect" aria-label="Floating label select example">
                                        <option value="0">
                                            select your nationality
                                        </option>
                                       <option *ngFor="let option of nationalityList" [value]="option.name" [selected]="option.selected">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <label for="floatingSelect">Nationality</label>
                                </div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                                <div class="form-floating" style="margin-left: 5px;">
                                    <select (change)="countryChangeValue($event)" class="form-select" id="floatingSelect" aria-label="Floating label select example">
                                        <option value="0">
                                            select your country of residence
                                        </option>
                                        <option *ngFor="let option of countryOfResidenceList" [value]="option.name" [selected]="option.selected">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <label for="floatingSelect">Country of residence</label>
                                </div>
                            </div>

                            <!--<div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                                <div class="form-floating" style="margin-right: 5px;">
                                    <span class="p-fluid">
                                        <label style=" z-index: 1; top: -12px; font-size: 12px; color: #818181; top: 5px; position: absolute; left: 15px;" for="phone">Nationality</label>
                                        <p-autoComplete placeholder="" id="floatingSelect" [(ngModel)]="selectedNationality" [suggestions]="filteredNationality" (completeMethod)="filterNationality($event)" field="name">
                                        </p-autoComplete>
                                    </span>
                                </div>
                            </div>-->
                            <!--<div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                                <div class="form-floating" style="margin-left: 5px;">
                                    <span class="p-fluid">
                                        <label style=" z-index: 1; top: -12px; font-size: 12px; color: #818181; top: 5px; position: absolute; left: 15px;" for="phone">Country of residence</label>
                                        <p-autoComplete placeholder="" id="floatingSelect" [(ngModel)]="selectedCountry" [suggestions]="filteredCountry" (completeMethod)="filterCountry($event)" field="name">
                                        </p-autoComplete>
                                    </span>
                                </div>
                            </div>-->
                        </div>

                        <!--<div *ngIf="step.stepCode=='@personal'" class="row">
                          <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                            <div class="form-floating" style="margin-right: 5px;">
                              <input [(ngModel)]="authentication.userData.fblink" type="text" class="form-control" id="floatingInputValueSubject">
                              <label for="floatingInputValueSubject">Your facebook URL</label>
                            </div>
                          </div>
                          <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom: 20px">
                            <div class="form-floating" style="margin-left: 5px; ">
                              <input [(ngModel)]="authentication.userData.linkedin" type="text" class="form-control" id="floatingInputValueSubject">
                              <label for="floatingInputValueSubject">Your linkedin URL</label>
                            </div>
                          </div>
                        </div>-->
                        <!--<div *ngIf="step.stepCode=='@personal'" class="row">
                          <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                            <div class="form-floating" style="margin-right: 5px;">
                              <input [(ngModel)]="authentication.userData.twitter" type="text" class="form-control" id="floatingInputValueSubject">
                              <label for="floatingInputValueSubject">Your twitter URL</label>
                            </div>
                          </div>
                        </div>-->

                        <div *ngFor="let detail of step.details" class="row">
                            <div *ngIf="detail.type == 'text'" class="col-xl-12 no-padding">
                                <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                    <div class="form-floating">
                                        <input [(ngModel)]="detail.value" type="text" class="form-control" id="floatingInputValueSubject">
                                        <label for="floatingInputValueSubject">{{detail.title}}</label>
                                    </div>
                                </div>

                                <!--<mat-form-field style="width:100%">
                                  <input maxlength="100" matInput [placeholder]="detail.title" [(ngModel)]="detail.value">

                                </mat-form-field>-->
                            </div>
                            <div *ngIf="detail.type == 'check'" class="col-xl-12 no-padding">
                                <mat-checkbox [(ngModel)]="detail.value" style="margin-bottom:20px">{{detail.title}}</mat-checkbox>
                            </div>
                            <div *ngIf="detail.type == 'label'" class="col-xl-12" style="margin-bottom:20px">
                                <div [innerHTML]="detail.title" style="width:100%">
                                </div>
                            </div>
                            <div *ngIf="detail.type == 'textarea'" class="col-xl-12 no-padding">
                                <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                    <div class="form-floating">
                                        <textarea style="height:200px" rows="5" maxlength="1000" class="form-control" [(ngModel)]="detail.value" id="floatingInputValueSubject"></textarea>
                                        <!--<input [(ngModel)]="detail.value" type="text" class="form-control" id="floatingInputValueSubject">-->
                                        <label for="floatingInputValueSubject">{{detail.title}}</label>
                                    </div>
                                </div>
                                <!--<mat-form-field style="width:100%">
                                  <textarea maxlength="1000" [(ngModel)]="detail.value" matInput [placeholder]="detail.title" matTextareaAutosize matAutosizeMinRows="3"
                                            matAutosizeMaxRows="7"></textarea>
                                </mat-form-field>-->
                            </div>
                            <div *ngIf="detail.type == 'textarea2'" class="col-xl-12 no-padding">
                                <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                    <div class="form-floating">
                                        <textarea style="height:200px" rows="5" maxlength="200" class="form-control" [(ngModel)]="detail.value" id="floatingInputValueSubject"></textarea>
                                        <!--<input [(ngModel)]="detail.value" type="text" class="form-control" id="floatingInputValueSubject">-->
                                        <label for="floatingInputValueSubject">{{detail.title}}</label>
                                    </div>
                                </div>

                                <!--<mat-form-field style="width:100%">
                                  <textarea maxlength="200" [(ngModel)]="detail.value" matInput [placeholder]="detail.title" matTextareaAutosize matAutosizeMinRows="3"
                                            matAutosizeMaxRows="7"></textarea>
                                </mat-form-field>-->
                            </div>
                            <div *ngIf="detail.type == 'drop'" class="col-xl-12 no-padding">


                                <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                    <div class="form-floating">
                                        <select (change)="formDrpChangeValue($event ,detail)" class="form-select" id="floatingSelect" aria-label="Floating label select example">
                                            <option value="">Select option</option>
                                            <option *ngFor="let value of  detail.detailValues" [value]="value.value">
                                                {{value.value}}
                                            </option>

                                        </select>
                                        <label for="floatingSelect">{{detail.title}}</label>
                                    </div>
                                </div>

                            </div>
                            <div *ngIf="detail.type == 'radio'" class="col-xl-12 no-padding" style="margin-bottom:20px">
                                <label style="width:100%;margin-bottom:10px" id="example-radio-group-label">{{detail.title}}</label>
                                <mat-radio-group aria-labelledby="example-radio-group-label"
                                                 class="example-radio-group"
                                                 [(ngModel)]="detail.value">
                                    <mat-radio-button style="display: block !important; padding-bottom: 10px !important;" class="" *ngFor="let value of  detail.detailValues" [value]="value.value">
                                        <span style="margin-right:10px">{{value.value}}</span>
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>
                            <!--<div *ngIf="detail.type == 'file'" class="col-xl-12" style="margin-top:20px;">
                              <div class="form-row">
                                <input type="file" (change)="filesSelect($event.target.files, detail)" name="file" id="file" class="inputfile" multiple />
                                <label for="file">{{detail.title}} <i class="far fa-file"></i></label>
                              </div>
                              <div class="col-xl-12" *ngFor="let file of files;let i = index">
                                <div *ngIf="file.filename != undefined" class="col-xl-12 text-left" style="margin-top:20px;">
                                  <a *ngIf="file.filename.length > 0" style="font-size: 15px !important;"><span class="fa fa-file" style="margin-right:15px"></span> {{file.filename}}</a>
                                  <a *ngIf="file.filename.length > 0" (click)="removeFile(i)" style="color:red;cursor: pointer;"><span class="fa fa-minus-circle" style="margin-left:15px"></span></a>
                                </div>
                              </div>

                            </div>-->



                        </div>
                        <div class="row" style="margin-top:50px">
                            <div class="col-md-6 col-sm-6 col-xs-6 text-left">
                                <button *ngIf="i > 0" mat-button matStepperPrevious class="btn mygistec-btn-outline float-left">Back</button>
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-6 text-right">
                                <button style="float: right;" class="btn mygistec-btn-outline float-right" *ngIf="i != form.formSteps.length - 1" mat-button matStepperNext>Next</button>
                                <button style="float: right;" *ngIf="i == form.formSteps.length - 1" [disabled]="btnDisabled" (click)="submit()" class="btn mygistec-btn-outline float-right">{{btnText}}</button>
                            </div>
                        </div>
                    </mat-step>

                </mat-stepper>

            </div>
        </div>





    </div>
</div>
